import { useState, useContext } from 'react';
import { AuthContext } from '../../contexts/authContext';
import { Home, FileText, BookOpen, Settings, Building, BarChart3, LogOut, ChevronLeft, User, Bell, Search } from 'lucide-react';

import logoMenu from '../../assets/pictures/logo-2024.png';
import GetArticles from '../components/artigos';

export default function Painel() {
  const [active, setActive] = useState("dashboard");
  const { user, signOut } = useContext(AuthContext);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  async function handleLogout() {
    try {
      signOut();
    } catch {
      console.error('Erro ao deslogar');
    }
  }

  const menus = [
    { id: "dashboard", label: "Dashboard", icon: <Home size={18} /> },
    { id: "artigos", label: "Artigos", icon: <FileText size={18} /> },
    { id: "treinamentos", label: "Treinamentos", icon: <BookOpen size={18} /> },
    { id: "configuracoes", label: "Configurações", icon: <Settings size={18} /> },
    { id: "empresa", label: "Empresa", icon: <Building size={18} /> },
    { id: "relatorio", label: "Relatórios", icon: <BarChart3 size={18} /> },
  ];

  // Conteúdo para cada seção
  const renderContent = () => {
    switch(active) {
      case "dashboard":
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Visão Geral</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-medium text-gray-700">Artigos</h3>
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <FileText size={20} className="text-blue-600" />
                  </div>
                </div>
                <p className="text-3xl font-bold text-gray-800">128</p>
                <p className="text-sm text-gray-500 mt-2">+12 desde a última semana</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-medium text-gray-700">Treinamentos</h3>
                  <div className="p-2 bg-green-100 rounded-lg">
                    <BookOpen size={20} className="text-green-600" />
                  </div>
                </div>
                <p className="text-3xl font-bold text-gray-800">24</p>
                <p className="text-sm text-gray-500 mt-2">+3 desde a última semana</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-medium text-gray-700">Relatórios</h3>
                  <div className="p-2 bg-purple-100 rounded-lg">
                    <BarChart3 size={20} className="text-purple-600" />
                  </div>
                </div>
                <p className="text-3xl font-bold text-gray-800">8</p>
                <p className="text-sm text-gray-500 mt-2">+2 desde o último mês</p>
              </div>
            </div>
            
            <div className="mt-10 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Atividades Recentes</h3>
              <div className="space-y-4">
                <div className="flex items-center border-b border-gray-100 pb-4">
                  <div className="bg-blue-100 p-2 rounded-full mr-3">
                    <User size={16} className="text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm font-medium">Novo artigo publicado</p>
                    <p className="text-xs text-gray-500">Há 2 horas</p>
                  </div>
                </div>
                <div className="flex items-center border-b border-gray-100 pb-4">
                  <div className="bg-green-100 p-2 rounded-full mr-3">
                    <User size={16} className="text-green-600" />
                  </div>
                  <div>
                    <p className="text-sm font-medium">Treinamento atualizado</p>
                    <p className="text-xs text-gray-500">Há 5 horas</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="bg-purple-100 p-2 rounded-full mr-3">
                    <User size={16} className="text-purple-600" />
                  </div>
                  <div>
                    <p className="text-sm font-medium">Relatório gerado</p>
                    <p className="text-xs text-gray-500">Ontem</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "artigos":
        return (
          <>
            <div className="p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Gestão de Artigos</h2>
              <p className="text-gray-600">Aqui você pode gerenciar todos os artigos do sistema.</p>
            </div>
            <GetArticles/>
          </>
        );
      case "treinamentos":
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-80git mb-6">Treinamentos</h2>
            <p className="text-gray-600">Aqui você pode gerenciar os treinamentos disponíveis.</p>
          </div>
        );
      case "configuracoes":
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Configurações</h2>
            <p className="text-gray-600">Aqui você pode configurar as preferências do sistema.</p>
          </div>
        );
      case "empresa":
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Dados da Empresa</h2>
            <p className="text-gray-600">Aqui você pode visualizar e editar os dados da empresa.</p>
          </div>
        );
      case "relatorio":
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Relatórios</h2>
            <p className="text-gray-600">Aqui você pode gerar e visualizar relatórios do sistema.</p>
          </div>
        );
      default:
        return (
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Dashboard</h2>
            <p className="text-gray-600">Seja bem-vindo ao painel administrativo.</p>
          </div>
        );
    }
  };

  return (
    <section className="flex bg-gray-50 min-h-screen">
      {/* Menu Lateral */}
      <aside className={`${isSidebarCollapsed ? 'w-16' : 'w-48'} flex flex-col bg-white shadow-md h-screen sticky top-0 overflow-y-auto transition-all duration-300 z-10`}>
        <div className="p-4 border-b border-gray-100 flex items-center justify-between">
          {!isSidebarCollapsed && (
            <div className="flex items-center justify-center w-full">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold mr-2">
                {user?.nome}
                {user?.sobrenome}
              </div>
              <picture className="mb-8 flex justify-center">
                <img src={logoMenu} alt="logo" className='w-36' />
              </picture>
            </div>
          )}
          <button 
            onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            className="p-1.5 rounded-md hover:bg-gray-100 transition-colors"
          >
            <ChevronLeft size={18} className={`transition-transform ${isSidebarCollapsed ? 'rotate-180' : ''}`} />
          </button>
        </div>

        <nav className="mt-4 flex-1 overflow-y-auto px-2">
          {menus.map((item) => (
            <button
              key={item.id}
              onClick={() => setActive(item.id)}
              className={`flex items-center w-full px-4 py-3 text-gray-700 rounded-lg mb-1 transition-all duration-200
                ${active === item.id 
                  ? "bg-blue-50 text-blue-600 font-medium" 
                  : "hover:bg-gray-50 hover:text-gray-900"}`}
            >
              <span className="flex-shrink-0">{item.icon}</span>
              {!isSidebarCollapsed && (
                <span className="ml-2 whitespace-nowrap">{item.label}</span>
              )}
            </button>
          ))}
        </nav>
        
        {/* Footer do menu lateral */}
        <div className="p-4 border-t border-gray-100 mt-auto">
          <button 
            onClick={handleLogout}
            className={`flex items-center w-full px-4 py-3 text-gray-700 rounded-lg transition-all duration-200 hover:bg-gray-50 ${isSidebarCollapsed ? 'justify-center' : ''}`}
          >
            <LogOut size={18} />
            {!isSidebarCollapsed && <span className="ml-2">Sair</span>}
          </button>
        </div>

        {!isSidebarCollapsed ? <div className="p-4 text-xs text-gray-400 text-center border-t border-gray-100">
          <span className='text-x1'>v 1.0.1</span>
        </div> : '' }
        
      </aside>

      {/* Conteúdo Principal */}
      <main className={`flex-1 transition-all duration-300 
      ${isSidebarCollapsed ? "pl-20" : "pl-64"}`}>
        {/* Top Menu */}
        <header className="bg-white shadow-sm py-4 px-6 flex items-center justify-between sticky top-0 z-10">
          <div className="flex items-center bg-gray-100 rounded-lg px-3 py-2 w-72">
            <Search size={18} className="text-gray-500 mr-2" />
            <input 
              type="text" 
              placeholder="Pesquisar..." 
              className="bg-transparent border-none outline-none text-sm w-full"
            />
          </div>

          <div className="flex items-center gap-4">
            <button className="p-2 rounded-full hover:bg-gray-100 relative">
              <Bell size={20} className="text-gray-600" />
              <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
            
            <div className="flex items-center">
              <div className="hidden md:flex flex-col items-end mr-4">
                <p className="text-sm font-medium text-gray-800">{user?.nome || "Usuário Admin"}</p>
                <span className="text-xs text-gray-500">{user?.sobrenome || "admin@empresa.com"}</span>
              </div>
              
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-medium text-sm">
                  {user?.nome?.charAt(0) || "U"}
                </span>
              </div>
            </div>
          </div>
        </header>

        {/* Breadcrumb e Título */}
        <div className="px-6 pt-6">
          <div className="flex items-center text-sm text-gray-500 mb-2">
            <span className="hover:text-gray-700 cursor-pointer">Home</span>
            <span className="mx-2">/</span>
            <span className="text-gray-700 font-medium">{menus.find(menu => menu.id === active)?.label || "Dashboard"}</span>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
            {menus.find(menu => menu.id === active)?.icon}
            {menus.find(menu => menu.id === active)?.label || "Dashboard"}
          </h1>
        </div>

        {/* Conteúdo interno */}
        <div className="p-6">
          {renderContent()}
        </div>
      </main>
    </section>
  );
}